import PillarsOfStrength from './PillarsOfStrength';

export type { TPillarsOfStrengthProps } from './PillarsOfStrength.types';
export { EPillarsOfStrengthTabs } from './PillarsOfStrength.types';

export default PillarsOfStrength;
